import { createZustandStore } from "@bounce/state-management"

import { getCodesFromParams, mergeCodes } from "../helpers/parseUrlParams"
import { getPersistedCodes, persist } from "../helpers/persist"
import type { ReferralsState } from "../types"

/**
 * See @bounce/referrals/README.md for more information.
 */
export const useReferrals = createZustandStore<ReferralsState>({
  name: "useReferrals",
  initializer: (set, _get) => ({
    codes: {},
    setCodes: codes => {
      set({ codes })
    },
    syncCodes: async ({ cookieDomain, urlParams }) => {
      const persistedCodes = await getPersistedCodes()
      const urlCodes = getCodesFromParams(urlParams)
      const mergedCodes = mergeCodes(urlCodes, persistedCodes, urlParams)
      await persist({ codes: mergedCodes, previousCodes: persistedCodes, cookieDomain })

      set({ codes: mergedCodes })
    },
  }),
})

export const { syncCodes } = useReferrals.getState()
